export const supportedDeserializerTypes = ["text/html"];
